module.exports = __webpack_public_path__ + "img/highland.9db9fd26.png";